export const goalHorizonHeaderStyles = { backgroundColor: "grey.100", boxShadow: "none", borderRadius: 2 };
